import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11 9H9V11H11V13H13V15H15V17H13V19H11V21H9V23H11V21H13V19H15V17H17V19H19V21H21V23H23V21H21V19H19V17H17V15H19V13H21V11H23V9H21V11H19V13H17V15H15V13H13V11H11V9Z\" fill=\"#595959\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol